import React, { useEffect, useState } from 'react';
import './FadeInText.css';

const FadeInText = ({ text, layout = '', isVisible, keepLastWordsTogether = false }) => {
  const words = text.trim().split(/\s+/);
  const [settledWordIndexes, setSettledWordIndexes] = useState([]);

  useEffect(() => {
    setSettledWordIndexes([]);

    if (!isVisible) {
      return undefined;
    }

    const timeoutIds = Array.from({ length: words.length }, (_, index) => {
      const wordDelay = 0.5 + index * 0.1;

      return setTimeout(() => {
        setSettledWordIndexes((currentIndexes) => (
          currentIndexes.includes(index) ? currentIndexes : [...currentIndexes, index]
        ));
      }, (wordDelay + 1) * 1000);
    });

    return () => timeoutIds.forEach(clearTimeout);
  }, [isVisible, text, words.length]);

  return (
    <div className={`fade-in-text fade-in-text--${layout} ${isVisible ? 'fade-in-text--visible' : 'fade-in-text--hidden'}`}>
      {words.map((word, index) => (
        <React.Fragment key={`${word}-${index}`}>
          <span
            className={`fade-in-text__word ${isVisible ? 'fade-in-text__word--visible' : 'fade-in-text__word--hidden'} ${settledWordIndexes.includes(index) ? 'fade-in-text__word--settled' : ''}`}
            style={{
              animation: isVisible && !settledWordIndexes.includes(index)
                ? `fade-in 1s ${0.5 + index * 0.1}s forwards cubic-bezier(0.11, 0, 0.5, 0)`
                : 'none'
            }}>
            {word}
          </span>
          {index !== words.length - 1 && (
            keepLastWordsTogether && index === words.length - 2 ? '\u00A0' : ' '
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default FadeInText;
